import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { dataTel3GetDetailPart } from "../../../config/apiSPA";

const ModalResultPart = ({ show, handleClose, id = null }) => {
  const [loadingPage, setLoadingPage] = useState(true);
  const [dataPart, setDataPart] = useState(null);
  useEffect(() => {
    if (!show) return;
    const loadData = async () => {
      try {
        setLoadingPage(true);
        const res = await dataTel3GetDetailPart(id);
        setDataPart(res.data);
        setLoadingPage(false);
      } catch (error) {}
    };
    loadData();
  }, [show]);
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Detail Result</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loadingPage ? (
          <p>Loading.....</p>
        ) : (
          <>
            <div className="mb-4">
              <h5>Hasil Penilaian</h5>
              {dataPart?.resultNumb.length > 0
                ? dataPart.resultNumb.map((item, index) => (
                    <div key={index} className="mb-3 p-3 border rounded">
                      <div className="text-theme">{item.question.questionText}</div>
                      <div className="text-muted">
                        Score: <span className="fw-bold">{item.score}</span>
                      </div>
                    </div>
                  ))
                : ""}
            </div>

            <div className="mb-4">
              <h5>Kesimpulan</h5>
              {dataPart?.resultText.length > 0
                ? dataPart.resultText.map((val, index) => (
                    <div key={index} className="p-3 border rounded mb-3">
                      <div className="mb-2 text-theme">{val.question.questionText}</div>
                      <div className="text-muted">{val.ansText}</div>
                    </div>
                  ))
                : ""}
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-outline-theme" onClick={handleClose}>
          Got it
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalResultPart;
